__turbopack_context__.v({
  "autocomplete_container": "GeHO2W_autocomplete_container",
  "autocomplete_results": "GeHO2W_autocomplete_results",
  "is_open": "GeHO2W_is_open",
  "no_results_button": "GeHO2W_no_results_button",
  "search_form": "GeHO2W_search_form",
  "search_input": "GeHO2W_search_input",
  "search_link": "GeHO2W_search_link",
  "search_menu": "GeHO2W_search_menu",
  "search_menu_inner": "GeHO2W_search_menu_inner",
  "search_menu_wrapper": "GeHO2W_search_menu_wrapper",
  "search_submit_button": "GeHO2W_search_submit_button",
});
